/**
 * Valida que el estimado de entrega máximo no sea menor al mínimo.
 * Si alguno está vacío, la validación de "campo requerido" se maneja por separado, por lo que aquí se considera válido.
 * @param minDeliveryEstimate estimado mínimo en semanas (string entero)
 * @param maxDeliveryEstimate estimado máximo en semanas (string entero)
 * @returns true si el rango es válido (máx ≥ mín) o si falta algún valor
 */
export const isDeliveryEstimateRangeValid = (minDeliveryEstimate: string, maxDeliveryEstimate: string): boolean => {
  if (!minDeliveryEstimate || !maxDeliveryEstimate) return true;
  return parseInt(maxDeliveryEstimate) >= parseInt(minDeliveryEstimate);
};
